module.exports = __webpack_public_path__ + "static/img/lshy81.08a6d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lshy81.png
// module id = HcTu
// module chunks = 73